import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useMemo } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";

import {
  DOT_SIZE,
  MIN_GAP_PERCENT,
  MOBILE_DOT_SIZE,
  MOBILE_MIN_GAP_PERCENT,
} from "./constants";
import { buildNewsDots } from "./newsDots";

export const useNewsDots = () => {
  const { news, timeline } = useCoreChart();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const dotSize = isMobile ? MOBILE_DOT_SIZE : DOT_SIZE;
  const minGapPercent = isMobile ? MOBILE_MIN_GAP_PERCENT : MIN_GAP_PERCENT;

  const dots = useMemo(
    () => buildNewsDots(news, timeline, minGapPercent),
    [news, timeline, minGapPercent]
  );

  return { dots, dotSize, isMobile };
};
